import React from "react";

/**
 * Wordmark-style ALTARODA logo.
 * The red glyph (a stylised wheel) plus the wordmark.
 * `variant` = 'light' for dark backgrounds (sidebar/login) or 'dark' for light bg.
 */
export function AltarodaLogo({ variant = "dark", size = 22, className = "" }) {
  const wordColor = variant === "light" ? "#FFFFFF" : "#111827";
  return (
    <div
      className={`inline-flex items-center gap-2 ${className}`}
      aria-label="ALTARODA"
    >
      <span
        className="inline-flex items-center justify-center shrink-0"
        style={{ width: size + 4, height: size + 4 }}
      >
        <img
          src={`${process.env.PUBLIC_URL || ""}/altaroda-logo.png`}
          alt="ALTARODA"
          width={size + 4}
          height={size + 4}
          className="object-contain"
          style={{ width: size + 4, height: size + 4 }}
          draggable={false}
        />
      </span>
      <span
        style={{
          color: wordColor,
          fontWeight: 700,
          letterSpacing: "0.08em",
          fontSize: 14,
        }}
      >
        ALTARODA
      </span>
    </div>
  );
}

export default AltarodaLogo;
